import { observer } from 'mobx-react-lite'
import { KEYWORD_DESCRIPTION_LIMIT } from 'shared/constants/limits'
import { TextInput } from 'shared/ui'
import { useKeywordViewContext } from 'pages/keywords/context'

import styles from './styles.module.scss'

export const KeywordDescription = observer(() => {
  const { setTitle, removeError, title, errorsMap } = useKeywordViewContext()

  const error = errorsMap.get('title')

  return (
    <TextInput
      size='small'
      placeholder={'Add internal description'}
      value={title}
      setValue={setTitle}
      error={error}
      onFocus={() => removeError('title')}
      limit={KEYWORD_DESCRIPTION_LIMIT}
      className={styles.keywordDescription}
      ariaLabel='KeywordDescription'
    />
  )
})
